import { render } from "./DropdownMenuCustom.vue?vue&type=template&id=f91bda48"
import script from "./DropdownMenuCustom.vue?vue&type=script&lang=js"
export * from "./DropdownMenuCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__